import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGraphUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.275 17.3C2.09167 17.1167 2 16.8873 2 16.612C2 16.3373 2.09167 16.1 2.275 15.9L8.275 9.85C8.375 9.76667 8.48333 9.7 8.6 9.65C8.71667 9.6 8.84167 9.575 8.975 9.575C9.10833 9.575 9.23767 9.6 9.363 9.65C9.48767 9.7 9.59167 9.76667 9.675 9.85L12.975 13.15L18.175 8H16.575C16.2917 8 16.0543 7.90433 15.863 7.713C15.671 7.521 15.575 7.28333 15.575 7C15.575 6.71667 15.671 6.479 15.863 6.287C16.0543 6.09567 16.2917 6 16.575 6H20.575C20.8583 6 21.0957 6.09567 21.287 6.287C21.479 6.479 21.575 6.71667 21.575 7V11C21.575 11.2833 21.479 11.5207 21.287 11.712C21.0957 11.904 20.8583 12 20.575 12C20.2917 12 20.0543 11.904 19.863 11.712C19.671 11.5207 19.575 11.2833 19.575 11V9.4L13.675 15.3C13.575 15.4 13.4667 15.4707 13.35 15.512C13.2333 15.554 13.1083 15.575 12.975 15.575C12.8417 15.575 12.7167 15.554 12.6 15.512C12.4833 15.4707 12.375 15.4 12.275 15.3L8.975 12L3.65 17.325C3.46667 17.5083 3.24167 17.6 2.975 17.6C2.70833 17.6 2.475 17.5 2.275 17.3Z",
		fill: "currentColor"
	})
});
export default SvgGraphUp;
